import Sponsors from "../landing/sponsors";
import Overlay from "../Overlay";
import Benefits from "./Benefits";
import Form from "./Form";
import Intro from "./Intro";

const Franchisee = () => {
  return (
    <>
      <Overlay />
      <Intro />
      <Sponsors />
      <Benefits />
      <Form />
    </>
  );
};

export default Franchisee;
